import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "prototype" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      src: _ctx.embedUrl,
      frameborder: "0",
      allowfullscreen: "",
      class: _normalizeClass(_ctx.prototype.target === 'app' ? 'contentMobile' : 'contentWeb')
    }, null, 10, _hoisted_2),
    _createElementVNode("img", {
      src: _ctx.targetMockup,
      alt: _ctx.targetMockupLabel,
      class: _normalizeClass(_ctx.prototype.target === 'app' ? 'mobileFrame' : 'frame')
    }, null, 10, _hoisted_3)
  ]))
}